import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

import Searches from '../../../stores/searches'

@inject('websites')
@observer
export default class AutoCompleteSearches extends Component {
  website = this.props.websites.current
  searches = new Searches({ website: this.website })

  constructor(...args) {
    super(...args)
    this.searches.load()
  }

  render() {
    const { name, onSelect, selected, onCreateNew, clearAfterSelect, exclude } = this.props
    return (
      <StoreAutoComplete
        store={this.searches}
        name={name}
        exclude={exclude}
        selected={selected}
        onSelect={onSelect}
        onCreateNew={onCreateNew}
        createNewType="Search"
        placeholder="Select a Search"
        clearAfterSelect={clearAfterSelect} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/Searches.js